// extracted by mini-css-extract-plugin
export default {"wrapperPage":"PrivacyPolicy_wrapperPage__oUT+F","title":"PrivacyPolicy_title__HCxsB","content":"PrivacyPolicy_content__K7z61"};